printVoucher.classy.controller({
    name: "PrintVoucherController",
    inject: ["$scope", "$q", "$stateParams", "$sce", "$http", "VouchersModelService", "SchoolModelService", 
        "authServiceFactory", "voucher", "school"],
    init: function() {
        this.$scope.CalculationService = this.CalculationService;
        this.$.$sce = this.$sce;
        this.$.ApplicationService = this.ApplicationService;
        this.$.loading = false;

        this.$.schooldata = this.school[0].data[0];
        this.$.voucher = this.voucher;
    },
    momentFormat: function(datetime) {
        let appSubmit = moment(datetime);
        return appSubmit.format("MM-DD-YYYY");
    }
});
